export default __webpack_public_path__ + "static/8-29bf7c0cb5c0fdd24ae22a687a1dbfed.webp";